import { langRoutePath } from '@bcf-v2/routes/common/app/paths/lang-route-path';
import { slotsRouteI18n } from '../i18n/slots-route-i18n';

export function slotsRoutePath(): string {
  return `${langRoutePath()}/${slotsRouteI18n()}`;
}
